<template>
    <Modal
      @closeModal="handleCerrar"
      :showMovilHeader="true"
      :fit="true"
      :showHeader="false"
      :linea="false"
    >
    <div class="closeModal-container">
        <img @click="handleCerrar" class="hide-movil " src="@/assets/imgs/icons/icono-cerrarModal.svg" />
    </div>
      <div class="body-container">
     
        <img class="img" src="@/assets/imgs/icons/icono-falla.svg" />
        <p class="title">{{ mensaje }}</p>
  
    
      </div>
    </Modal>
  </template>
  
  <script>
  import Modal from "../Modales/Modal.vue";
  export default {
    components: {
      Modal,
    },
    emits: ["cerrar"],
    props: {
      mensaje: {
        type: String,
        default: "Ha ocurrido un error. Intenta de nuevo"
      },
    },
    methods: {
      handleCerrar() {
        this.$emit("cerrar");
      },
      editarStatus() {
        this.$emit("editar", { status: this.status?.status, id: this.status.id });
      },
    },
    computed: {
      getStatus() {
        switch (this.status?.status) {
          case 0:
            return "cancelar";
          case 1:
            return "pendiente";
          case 2:
            return "no asistio";
          case 3:
            return "asistio";
          default:
            return "pendiente";
        }
      },
    },
  };
  </script>
  
  <style scoped>

.hide-movil{
    cursor: pointer;
}
 
  .body-container {
      height: 350px;
      width: 590px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
  }
  .img {
    widows: 80px;
    height: 95px;
  }

  .closeModal-container{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
  }
  .closeModal-container img{
    height: 23px;
    width: 23px;
  }
  .title {
      margin-top: 30px;
    width: 100%;
    text-align: center;
    font: normal normal bold 20px/27px Open Sans;
    letter-spacing: 0px;
    color: #0A4F9C;
  }
  
  

  
  @media screen and (max-width: 767px) {
    .title {
      font: normal normal bold 14px/19px Open Sans;
    }
    .body-container {
        width: 100%;
        width: 350px;
      padding: 20px;
      height: 100vh;
    }
    .hide-movil{
    display: none;
  }
    
  }
  </style>
  